export default "__VITE_ASSET__DEyZ8spk__"